import { render } from "./ShairiContent.vue?vue&type=template&id=76670157&scoped=true"
import script from "./ShairiContent.vue?vue&type=script&lang=js"
export * from "./ShairiContent.vue?vue&type=script&lang=js"

import "./ShairiContent.vue?vue&type=style&index=0&id=76670157&scoped=true&lang=css"

import exportComponent from "/pro/vue/Attamayyuz_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76670157"]])

export default __exports__